var words = {
  common: {
    new_deploy_version: 'There is a new version of system.',
    clic_to_update: 'Reload',
    accept: 'Accept',
    approve: 'Approve',
    add: 'Add',
    cancel: 'Cancel',
    description: 'Description',
    delete: 'Delete',
    title: 'Title',
    save: 'Save',
    faq: 'FAQ',
    contact: 'Contact Us',
    tos: 'Terms of Service',
    policy: 'Privacy Policy',
    edit: 'Edit',
    confirmation: 'Confirmation',
    select_all: '.: Select all :.',
    no_data: '.: No data :.',
    select: '.: Select :.',
    selected: 'Selected',
    yes: 'Yes',
    no: 'No',
    field_required: 'Field required',
    pending: 'Pending',
    approved: 'Approved',
    declined: 'Declined',
    validate: 'Validate',
    all_a: 'All',
    massive: 'Massive',
    download_template: 'Descargar plantilla',
    upload_file: 'Subir archivo',
    register: 'Register',
    search_commun: 'Search and request Access to Tables'
  },
  board: {
    titlePlaceholder: 'Enter a title for this card',
    deleteDescription: 'Are you sure you want to delete this card?',
    editCard: 'Edit Card',
    deleteCard: 'Delete Card',
    state: {
      TODO: 'TO DO',
      INPROGRESS: 'INPROGRESS',
      TESTING: 'TESTING',
      DONE: 'DONE'
    }
  },
  chat: {
    online: 'Users Online ({count})',
    addChannel: 'Add Channel',
    channel: 'Channel | Channels',
    message: 'Message'
  },
  email: {
    compose: 'Compose Email',
    send: 'Send',
    subject: 'Subject',
    labels: 'Labels',
    emptyList: 'Empty email list',
    inbox: 'Inbox',
    sent: 'Sent',
    drafts: 'Drafts',
    starred: 'Starred',
    trash: 'Trash',
    work: 'Work',
    invoice: 'Invoice'
  },
  todo: {
    addTask: 'Add Task',
    tasks: 'Tasks',
    completed: 'Completed',
    labels: 'Labels'
  },
  dashboard: {
    activity: 'Activity',
    weeklySales: 'Weekly Sales',
    sales: 'Sales',
    recentOrders: 'Recent Orders',
    sources: 'Traffic Sources',
    lastweek: 'vs last week',
    orders: 'Orders',
    customers: 'Customers',
    tickets: 'Support Tickets',
    viewReport: 'View Report'
  },
  usermenu: {
    profile: 'Profile',
    signin: 'Sign In',
    dashboard: 'Dashboard',
    signout: 'Sign Out'
  },
  error: {
    notfound: 'Page Not Found',
    other: 'An Error Ocurred'
  },
  check: {
    title: 'Set New Password',
    backtosign: 'Back to Sign In',
    newpassword: 'New Password',
    button: 'Set new password and Sign in',
    error: 'The action link is invalid',
    verifylink: 'Verifying link...',
    verifyemail: 'Verifying email address...',
    emailverified: 'Email verified! Redirecting...'
  },
  forgot: {
    title: 'Forgot Password?',
    subtitle: 'Enter your account email address and we will send you a link to reset your password.',
    email: 'Email',
    button: 'Request Password Reset',
    backtosign: 'Back to Sign In'
  },
  login: {
    title: 'Sign In',
    email: 'Email',
    password: 'Password',
    button: 'Sign In',
    orsign: 'Or sign in with',
    forgot: 'Forgot password?',
    noaccount: "Don't have an account?",
    create: 'Create one here',
    error: 'The email / password combination is invalid'
  },
  register: {
    title: 'Create Account',
    name: 'Full name',
    email: 'Email',
    password: 'Password',
    button: 'Create Account',
    orsign: 'Or sign up with',
    agree: 'By signing up, you agree to the',
    account: 'Already have an account?',
    signin: 'Sign In'
  },
  utility: {
    maintenance: 'In Maintenance'
  },
  faq: {
    call: 'Have other questions? Please reach out '
  },
  ecommerce: {
    products: 'Products',
    filters: 'Filters',
    collections: 'Collections',
    priceRange: 'Price Range',
    customerReviews: 'Customer Reviews',
    up: 'and up',
    brand: 'Brand',
    search: 'Search for product',
    results: 'Results ( {0} of {1} )',
    orders: 'Orders',
    shipping: 'Shipping',
    freeShipping: 'Free Shipping',
    inStock: 'In Stock',
    quantity: 'Quantity',
    addToCart: 'Add To Cart',
    buyNow: 'Buy Now',
    price: 'Price',
    about: 'About this item',
    description: 'Description',
    reviews: 'Reviews',
    details: 'Product Details',
    cart: 'Cart',
    summary: 'Order Summary',
    total: 'Total',
    discount: 'Discount',
    subtotal: 'Subtotal',
    continue: 'Continue Shopping',
    checkout: 'Checkout'
  },
  home_page_text: {
    access_requests: 'Access requests',
    acess_granted: 'Access granted',
    sandbox_created: 'Sandbox created',
    segments_exported: 'Segments exported',
    created_audiences: 'Created audiences',
    loaded_dataentries: 'Loaded dataentries',
    data_managment: 'Data Managment',
    attribute_marketplace: 'Attribute Marketplace',
    digital_audiences: 'Digital Audiences',
    customer_insights: 'Customer Insights'
  },
  menu: {
    toolbar: {
      table_views: 'Tables / Views',
      tables: 'Tables',
      views: 'Views',
      business_terms: 'Business Terms',
      tbl_datasources: 'TBL Datasources',
      tbl_dashboards: 'TBL Dashboards',
      pbi_datasets: 'PBI Datasets',
      pbi_reports: 'PBI Reports',
      gds_reports: 'LS Reports',
      gds_datasources: 'LS Datasources',
      all: 'All'
    },
    query_by: {
      title: 'Title',
      project: 'Project',
      dataset: 'Dataset',
      description: 'Description',
      columns: 'Columns',
      definition: 'Definition',
      also_known_as: 'Also Known As',
      area: 'Area',
      business_definition: 'Business Definition',
      data_element_name: 'Data Element Name',
      data_operator: 'Data Operator',
      domain: 'Domain',
      official_source: 'Official Source',
      org: 'Organization',
      subdomain: 'Subdomain',
      zone: 'Zone',
      data_owner: 'Data Owner'
    },
    query_by_search: 'Advanced Search',
    object_type: 'Object type',
    final_table: 'Final Table',
    logout: 'Logout',
    home_page: 'Home Page',
    use_metrics: 'Use Metrics',
    use_metrics_sub: {
      summary: 'Overview',
      data_management: 'Module Data Management',
      attributes: 'Module Marketplace Attributes',
      audiences: 'Module Digital Audiences',
      insights: 'Module Insights',
      mlops: 'Module MLOps',
      assets_corp: 'Asset Governance',
      tables_government: 'Table Governance',
      quality_government: 'Quality Governance',
      security_government: 'Security Governance',
      dashboard_government: 'Dashboard Governance',
      maturity_government: 'Maturity Governance'
    },
    asset_governance: 'Asset Governance',
    asset_governance_sub: {
      reports: 'Reports',
      maintenance: 'Maintenance'
    },
    performance_evaluation: 'Performance Evaluation',
    performance_evaluation_sub: {
      evaluation: 'Evaluation'
    },
    data_strategy: 'Data Strategy',
    data_stretegy_sub: {
      assessment_maturity: 'Assessment of Analytical Maturity',
      assessment_maturity_admin: 'Maintenance Assessment'
    },
    data_platform: 'Data Management',
    dp: {
      user_settings: 'User Settings',
      my_profile: 'My Profile',
      initial_setup: 'Initial Setup',
      my_objects: 'My Objects',
      my_pendings: 'My Pendings',
      ownership: 'Ownership',
      access_requests: 'Access Requests',
      change_metadata: 'Change Metadata Requests',
      massive_setup: 'Massive Setup Requests',
      monitoring_audit: 'Monitoring and Optimization',
      monitoring: 'Monitoring',
      bigquery_consumption: 'BigQuery Consumption',
      inca_metrics: 'INCA Metrics',
      access_management: 'Access Management Report',
      tables_without_metadata: 'Tables Without Metadata Report',
      executive_dashboard: 'Executive Dashboard',
      operational_dashboard: 'Operational Dashboard',
      data_pipeline: 'Data Pipeline Lineage',
      power_bi_log: 'Usage Audit Report in Power BI',
      manage_power_bi_log: 'Manage Audit Power BI Report',
      monitoring_billing: 'Monitoring & Billing',
      monitoring_billing_reports: 'Reports',
      monitoring_billing_maintenance: 'Maintenance',
      my_tasks: 'My Tasks',
      table_assignments: 'Table Assignments',
      bulk_load: 'Bulk Load',
      download_metadata: 'Download Metadata',
      data_operator_update: 'Data Operator Update',
      add_tables_cron: 'Add Tables with Cron',
      sync_table_flag_inca: 'Sync Table Bigquery',
      tableau_objects: 'Tableau Objects',
      datasource_assignments: 'Datasource Assignments',
      dashboard_assignments: 'Dashboard Assignments',
      visualization_access: 'Visualization Access',
      business_glossary_terms_load_bulk: 'Business Glossary Terms Load Bulk',
      power_bi_objects: 'Power BI Objects',
      dataset_assignments: 'Dataset Assignments',
      report_assignments: 'Report Assignments',
      visualization_access_pbi: 'Visualization Access',
      data_studio_objects: 'Looker Studio Objects',
      report_assignments_gds: 'Report Assignments',
      visualization_access_gds: 'Visualization Access',
      all_requests: 'All Requests',
      data_quality: 'Data Quality',
      data_quality_dataplex: 'Data Quality (Dataplex)',
      profiling_validation: 'Profiling Validation Types',
      profiling_history: 'Profiling History',
      profiling_score: 'Profiling Score Parameters',
      profiling_dashboard: 'Profiling Dashboard',
      user_profile: 'Data Profile',
      up_area: 'Area',
      up_user_profile: 'User Profile',
      up_table_details: 'Table Details',
      up_profile_assignments: 'Profile Assignments',
      data_strategy: 'Data Strategy',
      business_glossary: 'Business Glossary',
      user_module_access: 'Módule Access',
      strategy_management: 'Strategy Managment',
      evaluation_report: 'Assessment of Analytical Maturity',
      admin_evaluation_report: 'Maintenance Assessment',
      artificial_intelligence: 'Artificial Intelligence Tools',
      generative_image: 'Generative Image IA'
    },
    audience: 'Digital Audience',
    aud: {
      segments: 'Segments',
      my_segments: 'My Segments',
      create_segment: 'Create Segment',
      cross_table: 'Enter Own Data',
      audiences: 'Audiences',
      my_audiences: 'My Audiences',
      create_audience: 'Create Audience',
      share: 'Share',
      performance: 'Performance',
      monetization: 'Monetization',
      omnicanal: 'Omnichannel analysis',
      analytics: 'Digital Analytics',
      merge_segment: 'Merge Segments',
      exception: 'Data Request',
      request_exception: 'New Request',
      requests: 'Requests',
      configuration: 'Configuration',
      restriction: 'Restricted Data',
      attribute_restriction: 'Restricted Attribute',
      config_flags: 'Configuration',
      coupons: 'Coupons',
      my_coupons: 'My Coupons',
      create_coupon: 'Create Coupons',
      activators: 'Activators',
      ads_accounts: 'Ads Account',
      reports: 'Reports',
      my_campaigns: 'Campaigns',
      upload_history: 'Upload History',
      variable: 'Variables',
      variable_group: 'Variable Group',
      campaigns: 'Campaigns',
      report: 'Report',
      sandbox: 'Sandbox'
    },
    attributes: 'Attributes Marketplace',
    data_ops: 'DataOps',
    dataops: {
      overview: 'Overview',
      new_orchestration: 'New Orchestration',
      import_script: 'Import Script',
      sub_title: 'DataOps Module',
      orchestration: 'Orquestation',
      executions_history: 'Executions History'
    },
    attrs: {
      overview: 'Overview',
      use_cases: 'Use Cases',
      search_attributes: 'Attribute search',
      business_cases: 'Business Cases',
      marketplace_setup: 'Marketplace Setup',
      create_sandbox: 'Create Sandbox',
      my_usecases: 'My Usecases',
      my_groups: 'My Groups',
      my_sandboxes: 'My Sandboxes',
      manage_productization_title: 'Manage Productization',
      manage_productizamanage_productization_subtitletion_subtitle: 'Requests for transfers to production that are registered in Productivize model type "base IDs with variables" will be displayed in this section to be able to review that they comply with the security and standard policies of Marketplace Attributes.',
      sandboxes: 'Sandboxes',
      upload_my_data: 'Upload My Data',
      manage_requests: 'Manage Requests',
      manage_production: 'Manage Productization',
      metrics: 'Maintenance Metrics report',
      manage_metrics: 'Manage Metrics Report',
      productize_model: 'Productize my case',
      create_attribute: 'Create Attribute',
      production_approvals: 'Production Approvals',
      user_tables_overview: 'User Tables Overview',
      business_case_indicators: 'Business Case Indicators',
      attribute_master: 'Attribute Master',
      quality_report: 'Quality Dashboard',
      manage_quality_report: 'Admin Quality Dashboard',
      reports: 'Reports',
      attribute_quality_shared: 'Attribute Quality Shared',
      attribute_quality: 'Calidad de Atributos',
      attribute_quality_consistency: 'Attribute Quality Consistency'
    },
    analytic_services: 'Analytics Services',
    analytic: {
      my_resources: 'My Resources',
      resources_requests: 'Resources Requests',
      pipelines: 'Pipelines',
      datasource: 'Datasource',
      store_procedure: 'Store procedure',
      config: 'Configuration',
      resource: 'Resource',
      ml_requests: 'Requests',
      ml_components: 'Components',
      ml_configs: 'Configurations',
      ml_projects: 'Projects',
      ml_ops: 'ML Ops',
      ml_pipelines: 'Pipelines',
      ml_builder: 'Builder'
    },
    customer_insights: 'Customer Insights',
    customer: {
      home: 'Home',
      somos1: 'Somos 1',
      somos1_home: 'Overview',
      companies: 'Companies',
      huascaran: 'Huascaran',
      maintenance: 'Maintenance',
      somos1_insights: 'Somos 1 - Reports',
      somos1_reports: 'Reports',
      tracking_dataentry: 'Tracking Dataentry',
      companies_reports_title: 'Companies - Reports',
      huascaran_reports_title: 'Companies - Reports',
      companies_reports: 'Reports',
      huascaram_reports: 'Reports',
      somos1_data_entry: 'Data Entry',
      usage_metricas: 'Usage Metrics',
      somos1_v2: 'Somos 1 - v2',
      somos1_v2_regional_1: 'Regional Indicators 1',
      somos1_v2_regional_2: 'Regional Indicators 2'
    },
    mlops: 'MLOps',
    configuration: 'Configuration',
    config: {
      data_governance: 'Data Dovernance Actions',
      roles: 'Roles & Users',
      maintenance: 'Maintenances',
      business_domains: 'Business Domains',
      domain_maintenance: 'Organizations',
      whitelist_maintenance: 'White List',
      log: 'Logins',
      settings: 'Settings'
    },
    chatbot_platform: 'Hub IA',
    ch: {
      permission_management: 'Permission management',
      user_management: 'User management',
      userpermission_management: 'User Permission management',
      channel_management: 'Channels Management',
      channel: 'Channels',
      channel_catalog: 'Channel Catalog',
      connect_website: 'Connect WebSite Chat',
      project_management: 'Chatbot Management',
      data_center: 'Data Center',
      bot_management: 'BOTs Management',
      dashboard_management: 'Dashboard',
      search_engine: 'Search Engine',
      chatbots: 'Chatbots',
      chatbot_main_menu: 'Chatbot Main Menu',
      agent_management: 'Agent Management',
      config: 'Chatbot Configuration'
    }
  },
  btns: {
    save: 'Save',
    search: 'Search',
    clean: 'Clean',
    back: 'Back',
    preview: 'Preview',
    close: 'Close',
    new: 'New',
    cancel: 'Cancel',
    ok: 'Ok',
    edit: 'Edit',
    remove: 'Remove',
    request: 'Request',
    refresh: 'Refresh',
    see_all: 'See all',
    register_selection: 'Register selection',
    start_request: 'Start Request',
    remove_item: 'Remove item',
    add_item: 'Add item',
    start: 'Start',
    add_table: 'Add Table',
    next: 'Next',
    confirm: 'Confirm'
  },
  titles: {
    search_filters: 'Search Filters',
    filters: 'Filters',
    view_profile: 'View Profile',
    edit_profile: 'Edit Profile',
    about_me: 'About Me',
    roles: 'Roles',
    general_description: 'General Description',
    my_segments: 'My Segments',
    create_segment: 'Create Segment',
    view_segment: 'View Segment',
    edit_segment: 'Edit Segment',
    cross_table: 'Enter Own Data',
    my_audiences: 'My Audiences',
    my_coupons: 'My Coupons',
    create_audience: 'Create Audience',
    view_audience: 'View Audience',
    edit_audience: 'Edit Audience',
    create_coupons: 'Create Coupons',
    view_coupons: 'View Coupons',
    edit_coupons: 'Edit Coupons',
    audience_detail: 'Audience Detail',
    coupons_detail: 'Coupons Detail',
    my_objects: 'My Objects',
    my_notifications: 'My Notifications',
    use_case_report: 'Use Case Report',
    add_base_ids: 'Add Base IDs',
    add_inca_base: 'Add INCA Base',
    add_sandbox_base: 'Add Sandbox Base',
    selected_attributes: 'Selected Attributes',
    edit_users_sandbox: 'Edit Sandbox Users',
    desencriptar_idsandbox: 'Export Base',
    add_attributes: 'New attribute group',
    edit_attributes: 'Edit attributes',
    edit_group_attributes: 'Edit attributes group',
    description: 'Description',
    attributes: 'Attributes',
    input_attributes: 'Input Attributes',
    export_events: 'Export Events',
    output_attributes: 'Output Attributes',
    logs: 'Logs',
    aws_exports: 'Export(AWS)',
    base_exports: 'Base Export',
    view_update_request: 'Work Environment Update Request',
    view_create_request: 'Work Enviroment Create Request',
    error: 'Something went wrong',
    success: 'Success',
    sanbdox_requests: 'Sandbox Requests',
    merge_segments: 'Merge Segments',
    ml_requests: 'ML Requests',
    ml_components: 'Components',
    ml_templates: 'Templates',
    ml_create_template: 'Create Template',
    change_enviroment: 'Change Enviroment',
    transformed_detail: 'Transformed Detail',
    extend_validity: 'Extend Validity'
  },
  error_messages: {
    error_general: "Your request couldn't be completed successfully, please try again.",
    register_use_case: "The use case registration couldn't be completed successfully, please try again.",
    duplicate_base: 'The base is already registered',
    not_attributes_selected: 'Not attributes selected',
    min_attribute_selection: 'You must select at least one attribute'
  },
  success_messages: {
    general: 'Your sandbox has been approved successfully.',
    operation_success: 'The operation completed successfully.',
    general_processing: 'Your request is being processed, a notification will be sent to you as soon as it is finished.',
    export_sandox: 'Sandox was exported',
    sandbox_request_rejected: 'Sandbox request was rejected',
    request_approved: 'Request was approved',
    update: 'Your request has been updated successfully.',
    requested: 'Your request has been sent successfully.',
    usecase_paused: 'Use case was paused'
  },
  rejected_messages: {
    request_rejected: 'Request was rejected'
  },
  // Vuetify components translations
  $vuetify: {
    badge: 'Badge',
    close: 'Close',
    dataIterator: {
      noResultsText: 'No matching records found',
      loadingText: 'Loading items...'
    },
    dataTable: {
      itemsPerPageText: 'Rows per page:',
      ariaLabel: {
        sortDescending: 'Sorted descending.',
        sortAscending: 'Sorted ascending.',
        sortNone: 'Not sorted.',
        activateNone: 'Activate to remove sorting.',
        activateDescending: 'Activate to sort descending.',
        activateAscending: 'Activate to sort ascending.'
      },
      sortBy: 'Sort by'
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}'
    },
    datePicker: {
      itemsSelected: '{0} selected',
      nextMonthAriaLabel: 'Next month',
      nextYearAriaLabel: 'Next year',
      prevMonthAriaLabel: 'Previous month',
      prevYearAriaLabel: 'Previous year'
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}'
      }
    },
    calendar: {
      moreEvents: '{0} more'
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Pagination Navigation',
        next: 'Next page',
        previous: 'Previous page',
        page: 'Goto Page {0}',
        currentPage: 'Current Page, Page {0}'
      }
    }
  },
  botones: {
    boton_crear: 'Create',
    boton_add: 'Add',
    boton_cancelar: 'Cancel',
    boton_aceptar: 'Accept',
    boton_buscar: 'Search',
    boton_guardar: 'Save',
    boton_volver: 'Back',
    boton_yes: 'YES',
    boton_apply: 'Apply',
    boton_reset: 'Reset',
    boton_download: 'Download',
    boton_aceptar_solicitudes: 'Accept requests',
    boton_siguiente: 'Next',
    boton_primero: 'First',
    boton_anterior: 'Prev',
    boton_aceptar_rechazar: 'Accept/Reject',
    boton_hide: 'Hide Details',
    boton_busqueda_avanzada: 'Advanced Search',
    descargar: 'Download current records',
    boton_asignar: 'Assign',
    boton_paso_anterior: 'Previous Step',
    boton_download_metadata: 'Download Metadata',
    boton_descargar_template: 'Download Template',
    boton_cargar_archivo: 'Upload File',
    boton_confirmar: 'Confirm',
    boton_cargar_csv: 'Select CSV File',
    boton_detalles: 'Details',
    boton_descargar_csv: 'Download CSV',
    boton_show_all_tables: 'Show All Tables',
    boton_show_some_tables: 'Show Some Tables',
    boton_asignar_operator: 'Assign data operator',
    boton_limpiar: 'Clean',
    boton_dashboard_all_operator: 'ASSIGN ALL DASHBOARDS TO TEMPORAL DATA OPERATOR',
    boton_dataset_all_operator: 'ASSIGN ALL DATASETS TO TEMPORAL DATA OPERATOR',
    boton_report_all_operator: 'ASSIGN ALL REPORTS TO TEMPORAL DATA OPERATOR',
    boton_datasource_all_operator: 'ASSIGN ALL DATASOURCES TO TEMPORAL DATA OPERATOR',
    boton_renew_access: 'Renew Access',
    boton_search_table: 'Search Table',
    boton_turn_on_work_env: 'Turn on',
    boton_turn_off_work_env: 'Turn off',
    boton_update: 'Update',
    boton_monitoring: 'Monitoring',
    boton_upload_image: 'Upload image',
    boton_copiar: 'Copy',
    boton_eliminar: 'Delete',
    boton_filtrar: 'Filter',
    boton_glossary: 'See Glossary',
    boton_sync: 'Sync',
    boton_assign_all: 'Assign all',
    boton_renew_assignment: 'Renew assignment',
    boton_massive_upload_users: 'Bulk Load',
    boton_select_all: 'Select All'
  },
  filtros: {
    search_filters: 'Search Filters',
    nombre: 'Name',
    tipo: 'Type',
    rango: 'Date Range',
    plataforma: 'Platform',
    estado: 'State',
    object: 'Object Name',
    data_operator: 'Data Operator',
    path: 'Path Name',
    environment: 'Environment:',
    domain: 'Domain:',
    activate: 'Activate',
    subdomain: 'Subdomain:',
    organization: 'Organization:',
    empresa: 'Company',
    register_date: 'Register Date',
    expire_date: 'Expiration Date',
    modified_date: 'Modified Date',
    created_date: 'Created Date'
  },
  frases: {
    no_requests: 'You dont have any request',
    new_tab: 'Open in new tab',
    assign: 'Assign metadata in dev/test environment',
    step_1: 'Step 1',
    step_2: 'Step 2',
    step_3: 'Step 3',
    bulk_load: 'Bulk Load Details',
    asignar_operator_modal: 'Assign data operator from',
    new_domain: 'Add new domain',
    new_subdomain: 'Add new subdomain',
    subdomain: 'Business Subdomain',
    delete_domain: 'Delete Domain',
    update_domain: 'Update Domain',
    delete_subdomain: 'Delete Subdomain',
    update_subdomain: 'Update Subdomain',
    no_access: 'You do not have access',
    no_tables: 'You do not have tables',
    no_found: 'Nothing was found',
    loading: 'Loading...',
    search_table: 'Search by table',
    select_option: 'Select an option...',
    project_id: 'Project ID',
    dataset_id: 'Dataset ID',
    table_name: 'Table Name',
    search_datasource: 'Search',
    dev_test: 'Development / Test',
    prod: 'Production',
    search_object: 'Search by object',
    search_operator: 'Search by data operator',
    search_path: 'Search by path',
    show_role: 'SHOW ROLE DETAILS',
    hide_role: 'HIDE ROLE DETAILS',
    search_tags: 'Search tags',
    choose_roles: 'CHOOSE ROLES',
    delete_rol: 'Delete rol?',
    search_email: 'Search by Email',
    delete_bdomain: 'Some subdomains and terms could be affected. Do you want to continue?',
    delete_bsubdomain: 'Some terms could be affected. Do you want to continue?',
    new_bterm: 'New business term',
    edit_bterm: 'Update business term',
    delete_bterm: 'This term is related to others, do you wanto to delete it anyway? This action could take some time.',
    is_critical: 'Is critical?',
    active: 'Is active?',
    shared: 'Is shared?',
    relationships: 'Relationships',
    is_contained: 'Is contained in',
    is_related: 'Is a related term from',
    is_type: 'Is a type of',
    is_used: 'Is used to calculate',
    activo: 'Active',
    updated_by: 'Updated by',
    update_date: 'Update Date',
    sure: 'Are you sure?',
    deactivate: 'Deactivate',
    delete: 'Delete',
    delete_user: 'Delete User',
    delete_confirm: 'Confirm delete',
    activate: 'Activate',
    email: 'Email details',
    new_email: 'Assign new dp email',
    permission: 'Object Permission',
    logs: 'Audits logs',
    email_inca: 'Email (INCA)',
    no_records: 'There are no records to show',
    delete_workspace: 'The service account must have administrator permissions on the workspace. Are you sure?',
    app: 'Apps',
    type: 'Score by validation type',
    field_type: 'Score by field type',
    table_type: 'Thresholds by table validation type',
    choose_type: 'Choose a type ...',
    filter: 'Filter',
    type_search: 'Type to Search',
    table_filter: "* Table filter: It must be in bigquery sql language (example: transaction_date = '2021-06-01')",
    profiling_version: 'Profiling Version',
    quantity: 'Q = Quantity',
    q_increased: 'Indicator increased compared to the previous profiling',
    q_decreased: 'Indicator decreased compared to the previous profiling',
    q_same: 'Indicator is the same compared to the previous profiling',
    rows_quantity: 'Rows quantity',
    table_key: 'Table Key(s)',
    unique_key: '% Unique key',
    reference_score: 'Reference Score:',
    comments: 'Comments',
    enter: 'Type a comment',
    edit_profiling: 'EDIT PROFILING',
    execute_profiling: 'EXECUTE PROFILING',
    error_profiling: 'ERROR PROFILING',
    want_error: 'What do you want to do with the error?',
    execute_error: 'EXECUTE PROFILING AFTER ERROR',
    new_execution: 'NEW PROFILING EXECUTION',
    want_profiling: 'Do you want to profile this table?',
    create: 'Create',
    edit: 'Edit',
    view: 'View',
    sensitive: 'Sensitive Data:',
    database: 'Database Engine:',
    data_operator: 'Data operator:',
    attach: 'ATTACH',
    project: 'Project:',
    table: 'Table:',
    request_work_env: 'Request work environment',
    view_request: 'View Request',
    consumption_work_env: 'Work Environments Consumption',
    successfully_updated: 'Updated successfully',
    successfully_registered: 'Registered successfully',
    rejected: 'The table was rejected',
    no_description: 'Description not available',
    no_notifications_title: 'No notifications',
    no_notifications: "You don't have notifications yet",
    welcome: 'Welcome,',
    use_case: 'Use Case',
    select_base: 'Select base',
    select_column: 'Period',
    alert_period_column: "The period field must be in date format and have the structure 'yyyy-mm-dd', where 'dd' will always be '01'. For example: '2023-05-01'.\n",
    alert_add_sandbox: "Note: Do not add sensitive information, that is, information that is directly related one-to-one with the company's 'party_id'. For example: 'nro_documento', 'nro_placa', 'nro_contrato', other internal codes, etc.",
    choose_party_id: 'Select party ID',
    reason: 'Reason',
    reason_required: 'Reason is required',
    party_id_required: 'The identity column (party_id / id_sandbox) was not found.',
    select_all: 'Select All',
    register: 'Register',
    update: 'Update',
    attributes_overview: 'Explore the news that the Attributes Marketplace has for you',
    table_view: 'Table or View',
    view_id_copied: 'View Id copied!',
    code_copied: 'Code copied',
    owner: 'owner',
    attrs_overview_message: 'Explore the news that the Attributes Marketplace has for you',
    insights_home: 'Welcome to the Customer Insights module',
    attrs_sandbox_owner: 'Sandbox Owner',
    search_table_view: 'Search Table / View',
    update_list: 'Update List',
    search: 'Search',
    attributes_selection: 'Attributes Selection',
    attributes_only_one_sa: 'Only one service account is allowed',
    warning_massive_approve_access: 'You must select at least one request',
    will_approve: 'will be approved',
    show_inheritance: 'Show inheritance',
    tables: 'Tables',
    list_values: 'List of Values',
    list_classifications: 'List of Classification (Tags)',
    productize_mi_usecase: 'Productize my usecase',
    productize_usecase: 'Productize Use Case',
    identified_ids: 'Identified IDs',
    duplicated_ids: 'Not identified IDs',
    not_identified_ids: 'Not identified IDs',
    export_transformed_attributes: 'Export of transformed attributes',
    attributes_group: 'My Groups'
  },
  nouns: {
    requests: 'request(s)'
  },
  warnings: {
    are_you_sure: 'Are you sure?',
    cancel_sandbox_request: 'The selected list of attributes and the fields you have already filled in will be deleted, are you sure?',
    sync_table: 'Are you sure you want to sync this table?'
  },
  form_profile: {
    display_name: 'Display name',
    email: 'Email',
    phone_number: 'Phone number',
    default_language: 'Default language',
    created: 'Created',
    las_sign_in: 'Last Sign In'
  },
  form_dops: {
    api_filters: 'Api Filters',
    company: 'Company Name :',
    group: 'Group Name :',
    zone: 'Zone Name :',
    execution_date: 'Execution Date :',
    job_code: 'Job Code :',
    local_filters: 'Local Filters',
    job_type: 'Job Type :',
    job_status: 'Job Status :',
    legend: 'Legend',
    orch: 'Orchestation',
    trans: 'Transformation'
  },
  form_segmento: {
    nombre: 'Segment Name',
    descripcion: 'Description:',
    tipo: 'Segment Type',
    formato: 'Format: INCA_Empresa_caracteristicas_MMYYYY',
    categorias: 'Categories',
    usuarios: 'Unique Users',
    filtros: 'Filters:',
    preVisualizacion: 'Pre Visualization',
    crearAudiencia: 'Create Audience',
    datosGenerales: 'General Data',
    atributos: 'Atributes',
    resumen: 'Summary',
    total_segment: 'Total Segment',
    total_match: 'Total Match',
    total_table: 'Total Table/View',
    total_match_table: 'Total Match',
    total_restriction: 'Total Restriction',
    total_restriction_help: 'Total number of restricted unique users.',
    total_segment_help: 'Total number of unique users that meet the conditions of the chosen filters.',
    total_match_help: 'Total number of unique users who have contact data from the Total Segment.',
    total_table_help: 'Total number of unique users of the Table/View.',
    total_merge_help: 'Total number of onique users from Merge.',
    total_match_table_help: 'Total number of unique users who have contact data from the Total of the Table/View.',
    total_match_merge_help: 'Total number of unique users who have contact data from Merge.',
    tooltip_no_edit_segment: 'You cannot edit this segment, because it is associated with {} audience(s).'
  },
  form_request_access: {
    nombre_segmento: 'Segment Name',
    empresa: 'Request Data from',
    fecha_hasta: 'Date Until',
    guardar: 'Save',
    volver: 'Back'
  },
  tbl_request_access: {
    from: 'Requested By',
    to: 'Org. Requested',
    request_by: 'Request User',
    fecha: 'Status Date',
    fecha_hasta: 'Until Date',
    estado: 'Status',
    acciones: 'Actions'
  },
  form_cruzar: {
    nombre: 'Name',
    proyecto: 'Project',
    tabla: 'Table'
  },
  form_audiencia: {
    segmento: 'Segment',
    segment_type_name: 'Segment Type',
    audiencia: 'Audience',
    coupons: 'Coupons',
    choose_frencuency: 'Choose frecuency',
    desde: 'From',
    hasta: 'To',
    frecuencia: 'Update Frequency',
    plataforma: 'Platforms',
    update_date: 'Update Day',
    ad_account: 'Ad Account',
    talonone_application: 'Application',
    talonone_campaign: 'Campaign',
    talonone_pattern: 'Coupon Pattern',
    talonone_valid_characters: 'Valid Characters',
    audience_type_google: 'Audience Type in Google Ads',
    app_id: 'App ID',
    app_id_type: 'App ID Type',
    select_app_id_type: 'Select App ID Type'
  },
  form_attrs_use_case: {
    organization: 'Organization',
    use_case: 'Use Case',
    users: 'Users',
    attributes_selected_number: 'Number of selected attributes',
    expiration_date: 'Expiration Date',
    detail: 'Use Case Detail',
    technical_name: 'Technical Name',
    response: 'Response',
    sandbox_project: 'Sandbox Project',
    sandbox_dataset: 'Sandbox Dataset',
    generated_views: 'Generated Views',
    filter: 'Filter',
    business_area: 'Business Area',
    columns_validation: 'Columns Validation'
  },
  form_attrs_productize_usecase: {
    model: 'Model',
    download_rules: 'Download Guidelines',
    use_case: 'Use Case',
    type_export: 'Type Export',
    segment: 'Segment',
    table_name: 'Table name',
    destination_scheme: 'Destination scheme (AWS)',
    process_date: 'Process Date',
    script: 'Attach Script',
    unique_load: 'Unique Load',
    attach_file: 'Attach file',
    next: 'Next',
    back: 'Back',
    finish: 'Save and execute',
    request: 'Request',
    validate: 'Validate',
    description: 'Export detail',
    description_segment: 'Segment description',
    description_table: 'Table description',
    message_no_tables: 'No se encuentran tablas',
    user: 'User',
    date_hour: 'Date and hour',
    frecuency: 'Frecuence',
    day: 'Day',
    download_file: 'Download file',
    approve: 'Approve',
    deny: 'Deny',
    response_text: 'Response Text',
    change: 'Change',
    organization: 'Organization',
    exported_table: 'Exported Table'
  },
  tabla_segmentos: {
    empresa: 'COMPANY',
    nombre: 'NAME',
    tipo: 'TYPE',
    mod: 'MODIFICATION DATE',
    usuarios: 'UNIQUE USERS',
    total_audiences: 'TOTAL AUDIENCES',
    acciones: 'ACTIONS'
  },
  tabla_audiencias: {
    empresa: 'COMPANY',
    nombre: 'NAME',
    plataforma: 'PLATFORM',
    estado: 'STATE',
    fecha: 'REGISTER DATE',
    registros: 'REGISTERS',
    acciones: 'ACTIONS',
    last_process_date: 'LAST PROCESS DATE',
    end_date: 'EXPIRATION DATE'
  },
  tabla_solicitudes: {
    name: 'Code',
    type: 'Type',
    status: 'Status',
    created_date: 'Request Date',
    user_request: 'User Request',
    actions: 'Actions'
  },
  tabla_componentes: {
    name: 'Name',
    type: 'Type',
    created_date: 'Register Date',
    user_created: 'User',
    actions: 'Actions'
  },
  table_notifications: {
    title: 'TÍTLE',
    description: 'DESCRIPTION',
    created_date: 'DATE',
    created_by: 'CREATED BY',
    actions: 'ACTIONS'
  },
  table_my_work_envs: {
    notebook: 'Notebook',
    project_gcp: 'Project GCP',
    link: 'Link',
    requested_date: 'Requested Date',
    pr_234: 'Project Firebase',
    applicant: 'Applicant',
    init: 'Business Case',
    company: 'Company',
    status: 'Status',
    actions: 'Actions'
  },
  table_ownership_history: {
    organization: 'Organization',
    use_case: 'Use Case',
    scenario: 'Scenario',
    date_created: 'Creation Date',
    attributes: 'Attributes',
    owner: 'Owner',
    status: 'Status',
    states: {
      active: 'Active',
      inactive: 'Inactive',
      saved: 'SAVED',
      requested: 'REQUESTED',
      approved: 'APPROVED',
      rejected: 'REJECTED',
      finished: 'FINISHED',
      error: 'ERROR'
    },
    actions: {
      see_report: 'See Report',
      register_filter: 'Register filter',
      add_ids: 'Add INCA Base',
      edit_attrs: 'Edit attributes',
      edit_users: 'Edit users',
      go_sandbox: 'Go to Sandbox',
      add_sandbox_base: 'Add Sandbox Base',
      desencriptar_idsandbox: 'Exportar Base',
      edit_request: 'Edit Request',
      export_aws: 'Export to AWS',
      increase_validity: 'Increase validity',
      create_attribute_group: 'Create Group'
    }
  },
  table_sandbox_requests: {
    organization: 'Organization',
    use_case: 'Use Case',
    owner: 'Owner',
    date_created: 'Request Creation Date',
    attributes: 'Attributes'
  },
  table_add_ids: {
    attribute: 'Attribute',
    definition: 'Definition',
    type: 'Type'
  },
  table_selected_attributes: {
    name: 'Name',
    description: 'Description',
    data_type: 'Type',
    percentage: '% no null'
  },
  table_attributes_use_case_detail: {
    attribute: 'Attribute',
    description: 'Description',
    source: 'Source',
    data_type: 'Data type'
  },
  table_use_case_logs: {
    description: 'Description',
    log_type: 'Log Type',
    applicant: 'Applicant',
    response: 'Response',
    created: 'Created'
  },
  crear_audiencia: {
    diaria: 'Daily',
    semanal: 'Weekly',
    quincenal: 'Biweekly',
    mensual: 'Monthly',
    semestral: 'Semiannual',
    fechaInicio: 'Start Date',
    fechaFin: 'End Date'
  },
  descripcion: {
    des_business_glossary: 'Represents a means of sharing internal vocabulary within an organization',
    my_access: 'List all the BigQuery tables that you have access.',
    my_tables: 'List all the BigQuery tables on wich you are a data operator',
    my_bterms: 'List all the business terms on wich you are a data operator',
    my_tbl_datasources: 'List all the Tableau datasources on wich you are a data operator',
    my_tbl_dashboards: 'List all the Tableau dashboards on wich you are a data operator',
    my_pbi_datasets: 'List all the PowerBI datasets on which you are data operator',
    my_pbi_reports: 'List all the PowerBI reports on which you are data operator',
    my_gds_reports: 'List all the Looker Data Studio reports on which you are data operator',
    my_gds_datasources: 'List all the Looker Data Studio datasources on which you are data operator',
    o_my_tables: 'Data operator approvals for BigQuery tables',
    o_my_datasources: 'Data operator approvals for Tableau Datasources',
    o_my_dashboards: 'Data operator approvals for Tableau Dashboards',
    o_my_datasets: 'Data operator approvals for PowerBI Datasets',
    o_my_reports: 'Data operator approvals for PowerBI Reports',
    o_my_gds: 'Data operator approvals for Looker Data Studio Reports',
    o_my_gds_datasources: 'Data operator approvals for Looker Data Studio Datasources',
    a_my_tables: 'Access requests for BigQuery tables',
    a_my_datasources: 'Access requests for Tableau Datasources',
    a_my_dashboards: 'Access requests for Tableau Dashboards',
    a_my_datasets: 'Access requests for PowerBI Datasets',
    a_my_reports: 'Access requests for PowerBI Reports',
    a_my_gds: 'Access requests for Looker Data Studio Reports',
    a_my_gds_datasources: 'Access requests for Looker Data Studio Datasources',
    c_my_tables: 'Change metadata requests for BigQuery tables',
    c_my_datasources: 'Change metadata requests for Tableau Datasources',
    c_my_dashboards: 'Change metadata requests for Tableau Dashboards',
    c_my_datasets: 'Change metadata requests for PowerBI Datasets',
    c_my_reports: 'Change metadata requests for PowerBI Reports',
    c_my_gds: 'Change metadata requests for Looker Data Studio Reports',
    c_my_gds_datasources: 'Change metadata requests for Looker Data Studio Datasources',
    add_tables: 'Add new tables without metadata to INCA platform (only if the tables does not exist in the My Assignments option).',
    ownership_history: 'Check all your created Sandbox',
    ownership_requests: 'See the Sandbox pending request generated by the Intercorp companies',
    use_case_report: 'See Use Case detail',
    see_request_detail: 'See Request detail',
    requested_reason: 'Request reason',
    add_base_ids: 'You can search the customer base and select the columns you want to add',
    register_filter: 'Select the identifier base with which the attribute bases will be filtered. This table must be registered in the Sandbox. Only one base can be registered per Sandbox.',
    add_own_base: 'Select the table created in Sandbox and its party_id to be able to transform the id',
    select_columns: 'Now select the columns you want to register in the table (all page selection is enabled).',
    use_case: 'Sandbox Name',
    segment: 'Segment to be saved',
    segment_process_date: 'Date the segment was recorded',
    attrs_script_sql: 'SQL query that generates the base of IDs',
    companies_insights: 'You will only see the accesses of your organization enabled',
    companies_insights_title: 'Explore the reports we have for you',
    detail: 'Detail'
  },
  reglas: {
    nombre: 'Name is required',
    nombre_min: 'The name must have at least 3 characters',
    nombre_max: 'The name must have a maximum of 20 characters',
    nombre_max_10: 'The name must have a maximum of 10 characters',
    nombre_max_15: 'The name must have a maximum of 15 characters',
    nombre_formato: 'Must contain only letters, numbers and "_"',
    alias: 'Alias is required',
    descripcion: 'Description is required',
    proyecto: 'Project is required',
    dataset: 'Dataset is required',
    tabla: 'Table is required',
    end_date: 'End date is required',
    external_user_type: 'Select external user type',
    phone_required: 'Phone number is required',
    phone_regex: 'Phone number must have a + and the country code before the number. (Ex: +51)',
    response_required: 'Response is required',
    period: 'Period is required',
    field: 'This field is required',
    field_min: 'The field must contain at least 3 characters',
    field_max: 'The field must contain a maximum of 200 characters',
    wrong_emails: 'Wrong emails',
    invalid_email: 'The email must belong to Intercorp companies',
    email_no_inca: 'The e-mail was no authorized: attribute_user required',
    duplicate_email: 'The email is already registered',
    attributes_wrong_domain: "The email must belong to the use case's domain",
    insights_min_2_update_hours: 'At least 2 hours of update must be selected',
    domain: 'Domain is required',
    min_character_insights_3: 'the name must have at least 3 characters',
    max_character_insights_45: 'the name must have a maximum of 45 characters',
    max_character_insights_150: 'the name must have a maximum of 150 characters',
    year: 'Year is required'
  },
  rules_work_env: {
    email: 'Email is required',
    email_invalid: 'Email must be valid',
    business_case: 'Business case es requerido',
    company: 'Company is required',
    project_gcp: 'Project GCP is required',
    instance_type: 'Instance Type is required',
    image_type: 'Image type is required'
  },
  tabs: {
    access: 'My access',
    tables: 'My tables',
    bterms: 'My business terms',
    tbl_datasources: 'MY TBL datasources',
    tbl_dashboards: 'MY TBL dashboards',
    pbi_datasets: 'MY PBI datasets',
    pbi_reports: 'MY PBI reports',
    gds_reports: 'MY LS reports',
    gds_datasources: 'MY LS datasources',
    pages: 'PAGES',
    bterm: 'BUSINESS TERM',
    user: 'USERS',
    lineage: 'LINEAGE',
    logs: 'LOGS',
    rules: 'RULES',
    columns: 'COLUMNS',
    execution: 'EXECUTION DETAILS',
    profiling: 'PROFILING',
    connections: 'CONNECTIONS',
    general: 'General',
    specifications: 'Specifications',
    relationships: 'Relationships',
    graphical_relationships: 'Graphical Relationships',
    related_objects: 'Related Objects',
    values: 'Values',
    classifications: 'Classifications',
    audit_logs: 'Audit Logs',
    sandbox_internal: 'Internal'
  },
  fields: {
    type: 'Type',
    business_term: 'Business term',
    domain: 'Domain',
    subdomain: 'Subdomain',
    also_known_as: 'Also knon as',
    accountable: 'Accountable',
    status: 'Status',
    critical: 'Critical',
    shared: 'Shared',
    definition: 'Definition'
  },
  tablas: {
    table: 'Table',
    columns: 'Columns',
    column: 'Column',
    rows: 'Rows',
    creation_time: 'Creation Date',
    expiration_date: 'Expiration Date',
    actions: 'Actions',
    enviroment: 'Enviroment',
    bterm: 'Business Term',
    definition: 'Definition',
    values: 'Values',
    total: 'Total Tables',
    rol: 'Role',
    views: 'Views',
    report: 'Report',
    pages: 'Pages',
    applicant: 'Applicant',
    request_date: 'Request Date',
    area: 'Area',
    profile: 'Profile',
    status: 'Status',
    dominio_empresa: 'Dominio Empresa',
    organization: 'Organization',
    benefited: 'Benefited',
    application: 'Application',
    first_interaction: 'First Interaction',
    last_interaction: 'Last interaction',
    table_project: 'Table project',
    table_dataset: 'Table dataset',
    view_project: 'View Project',
    view_dataset: 'View dataset',
    view: 'View',
    data_operator: 'Data Operator',
    user: 'User',
    groups: 'Groups',
    user_inca: 'Usuario INCA',
    user_pbi: 'User PBI',
    name: 'Name',
    created_by: 'Created by',
    type: 'Type',
    domain: 'Domain',
    user_roles: 'User Roles',
    user_email: 'User Email',
    tags: 'Tags(classification)',
    aka: 'Also known as',
    accountable: 'Accountable',
    critical: 'Critical? (Y/N)',
    position: 'Position',
    supervisor: 'Supervisor',
    months: 'Months',
    project: 'Project',
    dataset: 'Dataset',
    creator: 'Creator',
    description: 'Description',
    capacity: 'Capacity',
    object: 'Object',
    object_type: 'Object Type',
    response_date: 'Response Date',
    end_date: 'End Date',
    weight: 'Weight',
    field_type: 'Field Type',
    table_type: 'Table Type',
    lower: 'Lower',
    upper: 'Upper',
    bterm_definition: 'Business Definition',
    validation_type: 'Validation Type',
    thresholds: 'Thresholds',
    primary_key: 'Primary Key',
    priority: 'Priority',
    partition: 'Partition',
    dimension: 'Dimension',
    version: 'Version',
    frequency: 'Execute frequency',
    upper_th: 'Upper threshold',
    lower_th: 'Lower threshold',
    table_filter: 'Table Filter*',
    specification: 'Specification',
    start_date: 'Start Date',
    execution_id: 'Execution ID',
    execution_date: 'Execution Date',
    id_detail: 'ID detail',
    rule_id: 'Rule ID',
    rule_code: 'Rule code',
    rule_name: 'Rule name',
    element_type: 'Element type',
    element_name: 'Element name',
    element_description: 'Element description',
    config_name: 'Config name',
    field: 'Field',
    sample_value: 'Sample value',
    partition_ini: 'Partition ini',
    partition_end: 'Partition end',
    flag_priority: 'Flag priority',
    flag_pk: 'Flag pk',
    load_date: 'Load date',
    creation_user: 'Creation user',
    itc_id: 'ITC company ID',
    itc_name: 'ITC company name',
    data_type: 'Data type',
    nullability: 'Nullability',
    no_null: '% no null',
    q_no_null: 'Q no null',
    q_null: 'Q null',
    empty: 'Empty',
    empty_space: '% Empty space',
    q_empty_space: 'Q Empty space',
    unicity: 'Unicity',
    unique_value: '% Unique value',
    numerical: 'Numerical',
    numeric: '% Numeric',
    q_no_numeric: 'Q no numeric',
    freq: 'Frequency',
    q_freq_value: 'Q freq value',
    most_freq_value: 'Most freq value',
    length: 'Length',
    max_length: 'Max Length',
    log_time: 'Log time',
    method: 'Method',
    message: 'Message',
    workspace: 'Workspace',
    relationship: 'Relationship',
    related_term: 'Related term',
    record_source: 'Record source',
    observation: 'Observation'
  },
  search: {
    all_results: 'All results',
    change: 'Change',
    clean: 'Limpiar',
    coincidences: 'Coincidences',
    continue_filtering: 'To continue filtering the button on the right',
    description: 'Descripción',
    domain: 'Domain',
    found_in: 'Founded in',
    no_results: 'No results found for your search',
    stats_title: 'Usage metrics (last 30 days)',
    stats_queries_30d: 'Queries',
    stats_users_30d: 'Distinct users',
    stats_last_queried_at: 'Last query',
    stats_last_queried_by: 'Last queried by',
    stats_empty: 'No queries recorded in the last 30 days',
    stats_computed_at: 'Data as of {fecha}',
    object_type: 'Object Type',
    request: 'Request',
    search: 'Search',
    search_filters: 'Search Filters',
    seconds: 'seconds',
    text: 'Text',
    view: 'View'
  },
  data_management: {
    placeholder: {
      organization: 'Organization',
      project: 'Project',
      dataset: 'Dataset',
      table: 'Table'
    },
    label: {
      organization: 'Organization',
      project: 'Search by project',
      dataset: 'Search by dataset',
      table: 'Search by table'
    }
  },
  data_estrategy: {
    title_evaluation_report: 'Assessment of Analytical Maturity',
    subtitle_evaluation_report: 'Assessment of Analytical Maturity sub',
    title_manage_evaluation_report: 'Assessment of Analytical Maturity',
    subtitle_manage_evaluation_report: 'Maintenance Assessment'
  },
  log_power_bi: {
    title: 'Usage Audit Report in Power BI',
    subtitle: '',
    title_manage_report: 'Maintenance Usage Audit Report in Power BI',
    subtitle_manage_report: ''
  },
  monitoring_billing: {
    title: 'Maintenance Monitoring',
    title_reports: 'Monitoring & Billing',
    subtitle: 'Manage billing reports',
    name: 'Name',
    description: 'Description',
    maintenance: 'Maintenance',
    reports_desc: 'Maintenance & Monitoring Reports'
  },
  attributes: {
    button: {
      search: 'search',
      confirm: 'confirm',
      back: 'Back',
      add_base: 'Add base',
      finalize: 'End',
      register_selection: 'Save selection',
      clean_selection: 'Clean selection',
      register: 'Register',
      edit: 'Edit',
      view_detail: 'View detail',
      add: 'Add',
      by_word: 'By word',
      by_group: 'By group'
    },
    label: {
      search: 'Search',
      category: 'Category',
      pct_not_null_without_value: '% not null without value',
      include_search_by_desc: 'Include search by name and description',
      semantic_search: 'Semantic search',
      include_search_by_extra_data: 'Include search by additional data',
      use_case_name: 'Use case name',
      duration: 'Sandbox duration',
      detail_use_case: 'use case detail',
      add_sa_by_business_area: 'Add service account by business area',
      users: 'Users',
      register_group_text: 'Register your group of selected attributes, which you can use in the different sandboxes that you request',
      title_view_attributes: 'Attributes Groups',
      my_custom_groups: 'My attribute groups',
      this_is_the_list_attributes: 'This is the list of attribute groups you have registered',
      name_es: 'Name (es)',
      name_en: 'Name (en)',
      group_date: 'Creation date',
      description_es: 'Description (es)',
      description_en: 'Description (en)',
      attribute_object_name: 'Object',
      attribute_scheme_name: 'Scheme',
      attribute_project_name: 'Project',
      alias: 'Alias',
      icon: 'Upload image',
      group_name: 'Group name',
      group_description: 'Description',
      total_records: 'Total records',
      has_not_party_match: 'No filter registered'
    },
    placeholder: {
      input_user: 'Enter email of new user you want to add',
      use_case: 'Filter by use case',
      input_segment: 'Enter segment name',
      select_process_date: 'Select process date',
      attach_script_sql_txt: 'Select file (.sql, .txt)'
    },
    discover_attributes: 'Discover the attributes of the group companies',
    search: {
      title: 'title',
      search: 'attributes search',
      corporate: 'Corporate',
      demographics: 'Demographics',
      digital: 'Digital',
      Retail: 'Retail',
      RCC: 'RCC',
      payments: 'Payments',
      insurance: 'Insurance',
      custom_attributes: 'My groups',
      for_a_keyword: 'Search for a keyword',
      select_an_attribute: 'Select an attribute category',
      user_groups_title: 'User-created attributes',
      user_groups_empty: 'No categories created by users for this company.',
      user_groups_select_company: 'Select a company',
      user_groups_no_companies: 'No companies available.',
      user_groups_company_breadcrumb: 'Companies',
      user_groups_only_with_content: 'Show only companies with categories',
      table_search_list: {
        name: 'Name',
        description: 'Description',
        data_type: 'Type',
        category: 'Category',
        percentage: '% not null',
        additional_data: 'Additional Data',
        actions: {
          title: 'Actions',
          see_report: 'View Report',
          add_ids: 'Add INCA Base',
          add_attrs: 'Add Attributes',
          go_sandbox: 'Go to Sandbox'
        }
      }
    },
    attributes_description: {
      corporate: 'Attributes at the corporate level of the clients of the Intercorp Group.',
      demographics: 'Demographic attributes of Intercorp Group customers from the m_customer table.',
      digital: 'Attributes based on customer behavior in the digital channel. Sessions, events, intentions to buy, etc.',
      Retail: 'Attributes of the customer profile in Retail companies (Peruvian Supermarkets, Peruvian Pharmacies, Oechsle, Promart).',
      RCC: 'Customer profile attributes in the Consolidated Credit Reports.',
      payments: 'Attributes based on payments generated with the Oh credit cards and Agora card of Intercorp Group customers.',
      insurance: 'Attributes based on the relationship and interaction with Interseguro products and services.',
      custom_attributes: "Groupings of attributes created by the organization's users focused on a specific use case.",
      not_identified_ids: 'IDs that are not registered within Intercorp'
    },
    group: {
      name: 'Name',
      definition: 'Definition',
      quantity: 'Quantity',
      owner: 'Owner'
    },
    sandbox: {
      request_title: 'Sandbox creation request',
      request_subtitle: 'Complete and/or confirm each phase to send your request',
      attribute_selection: 'Attribute Selection',
      confirm: "Confirm your selection or continue adding all the attributes you'll need for your use case",
      this_is_add: 'This will be added to your sandbox',
      quantity_attributes: 'Number of selected attributes',
      request: 'Request',
      complete_form: 'Complete the sandbox creation request form to be able to register the use case that you will carry out.',
      add_base_ids: 'Add base IDs',
      select_equivalent: 'Select the equivalent of the party_id, as well as the variables you would need from the table. Remember that this table will have to be published in INCA',
      list_base_adds: 'List of added bases',
      productize_model_desc: ''
    },
    error: {
      required: 'No se tiene atributos seleccionados'
    },
    managment: {
      attribute_master_title: 'Attribute Master',
      attribute_master_subtitle: 'Maintenance Attribute master',
      modal_add_attribute_master: 'Add attribute category',
      modal_edit_attribute_master: 'Edit attribue category',
      metrics: 'Metrics',
      manage_metrics: 'Maintenance Metrics report',
      headers: {
        category: 'Category',
        description: 'Description',
        table: 'Table Inca'
      },
      button: {
        create: 'New'
      },
      label: {
        add: 'Here you can register a new category of attributes. The name, description and logo will be necessary, which will then be displayed in the search menu. Remember that it must be linked to a table that is already published in the Data Management module',
        black_list: 'Here you can select the attributes that you want to hide, such as audit fields, upload date or quality fields.',
        search_list: 'Attributes search',
        selected_list: 'Not visible attributes'
      }
    }
  },
  customer_insights: {
    label: {
      somos1_data_entry: 'Data Entry',
      somos1_data_entry_desc: 'Upload the financial and operational indicators of your organization',
      somos1_v2_regional_1_title: 'Somos 1 v2 - Regional Indicators 1',
      somos1_v2_regional_1_desc: 'View the regional indicators 1 for Somos 1 v2',
      somos1_v2_regional_2_title: 'Somos 1 v2 - Regional Indicators 2',
      somos1_v2_regional_2_desc: 'View the regional indicators 2 for Somos 1 v2',
      somos1_reports: 'View your assigned reports with information from the Intercorp Customer Single View',
      somos1_data_entry_report: 'View the "We are 1" reports to which you have access',
      hand_upload: 'Hand upload',
      bulk_upload: 'Builk upload',
      organization: 'Organization',
      tipo_reporte: 'Option',
      indicator: 'Indicator',
      year: 'Year',
      month: 'Month',
      forecast: 'Forecast',
      brand: 'Brand',
      region: 'Region',
      general_indicators: 'General indicators',
      visitor_presentation: 'Visitor Presentation',
      visitor_presentation_sub: 'We show you which fields of your company template you must complete',
      complete_template: 'Remember that this template can only be completed once a month',
      visitor_step1: 'Step 1: Hightlights',
      visitor_step2: 'Step 2: Competitors',
      visitor_step3: 'Step 3: Metrics',
      tracking_dataentry: 'Tracking Data Entry',
      tracking_dataentry_sub: 'We show you the status of the Dataentry',
      view_info: 'View information',
      info: 'Information',
      last_info_updated: 'The latest information appearing in the report was uploaded by:',
      last_info_date: 'Last update date:'
    },
    button: {
      filter: 'Filter',
      download: 'Download',
      download_log: 'Log',
      send: 'Send'
    },
    rules: {
      organization: 'Select an organization',
      brand: 'Select a brand',
      indicator: 'Select an indicator',
      year: 'Select an year',
      month: 'Select a month',
      forecast: 'Select an option',
      file: 'Select a file',
      file_size: 'File is too big',
      tipo_reporte: 'Select an option'
    },
    bulk_upload: {
      title: 'Monthly KPIs',
      sub_title: 'Fill in the required information correctly',
      drag_here: 'Drag and drop here or',
      search_computer: 'search on your computer',
      download_it_now: "If you don't have the template yet, you can download it now",
      template: 'Template',
      budget_upload_btn: 'Budget upload'
    },
    forecast: {
      title: 'Forecasts',
      upload_btn: 'Forecast'
    },
    data_entry: {
      header: {
        year: 'year',
        city: 'city',
        january: 'january',
        february: 'february',
        march: 'march',
        april: 'april',
        may: 'may',
        june: 'june',
        july: 'july',
        august: 'august',
        september: 'september',
        october: 'october',
        november: 'november',
        december: 'december'
      }
    }
  },
  dataops: {
    orchestrator: 'Orquestrator',
    import_script: 'Import Script',
    job_executions_history: 'Job Executions History'
  },
  chatbots_translations: {
    wizard: {
      title: 'Connect WebSite Chat',
      description: 'Start setting up with basic configuration.',
      additional_resources: 'Additional Resources'
    },
    channel: {
      title: 'Channels',
      description: 'Manage your messaging channels and discover new ones to help you acquire more customers.'
    },
    channel_catalog: {
      title: 'Channels Catalog',
      description: 'Manage your messaging channels and discover new ones to help you acquire more customers.'
    }
  },
  user_access: {
    module: 'MÓDULE',
    history: 'HISTORY',
    last_3_month: 'LAST 3 MONTH',
    current_month: 'CURRENT MONTH',
    title: 'Login history',
    subtitle: 'History of users who accessed Inca',
    email: 'Email',
    domain: 'Domain'
  },
  help_center: {
    help_center: 'Help Center',
    hello: '¡Hello!, how can we help you?',
    question: 'Write your question',
    comunicate: 'Contact us',
    description: 'Description',
    functionalities: 'Main functionalities',
    gterms: 'Glossary of terms',
    manual: 'User manual',
    type: 'Type',
    section: 'In which section of INCA?',
    details: 'Details',
    comments: 'Additional comments (optional)',
    module: 'Module',
    responsible: 'Responsible',
    title: 'Title',
    informant: 'Informant',
    date: 'Date',
    news: 'News',
    read: 'Read and Learn',
    videos: 'Tutorial Videos',
    sugerences: 'Sugerences',
    feedback: 'Feedback',
    sugerence_alert: 'Your opinion is important to improve INCA Platform. Remember to complete all the sections to be able to know your ideas.'
  },
  crud: {
    View: 'View',
    Edit: 'Edit',
    Create: 'Create',
    Delete: 'Delete'
  },
  ownership_requests: {
    tabs: {
      sandbox: 'Sandbox',
      create_attribute: 'Create Attribute'
    },
    create_attribute: {
      use_case: 'Use case',
      table_name: 'Table name',
      periods: 'Periods',
      date: 'Date',
      operator: 'Operator',
      review: 'Review'
    },
    review_dialog: {
      title: 'Review Create Attribute request',
      script_label: 'Editable SQL script',
      revalidate: 'Revalidate with AI',
      approve: 'Approve and execute',
      reset_script: 'Restore script',
      edited_badge: 'Edited',
      lines_label: '{count} lines',
      validation_status_ok: 'Validation passed',
      validation_status_error: 'Has issues',
      validation_status_unknown: 'Pending validation',
      reason_label: 'Approval reason (optional)',
      revalidate_ok: 'Validation passed successfully.',
      revalidate_still_failing: 'Validation still shows issues.',
      approve_success: 'Request approved. The pipeline was started.',
      validation_ok: 'Partition validation passed successfully.',
      script_error: 'Could not load the stored script.',
      script_empty: 'The SQL script cannot be empty.',
      missing_original_data: 'Could not recover the original request information.',
      no_validation: 'No validation result is registered for this request.'
    }
  },
  create_attribute: {
    title: 'Create Attribute',
    new_automation: 'New automation',
    review: {
      sent_title: 'Sent for review',
      sent_message: 'Partition validation found issues. The automation was saved as Requested for an administrator to review.'
    },
    table: {
      company: 'Company',
      status: 'Status',
      created_date: 'Created Date',
      use_case: 'Use Case',
      table_name: 'Table Name',
      owner: 'Owner'
    },
    headers: {
      status: 'Status'
    },
    status: {
      active: 'Active',
      inactive: 'INACTIVE',
      processing: 'Processing',
      error: 'Error',
      pending: 'Pending',
      completed: 'Completed',
      solicitado: 'Requested',
      en_ejecucion: 'In progress',
      ejecutado: 'Executed',
      desactivo: 'INACTIVE'
    },
    filters: {
      company: 'Company',
      status: 'Status',
      all_statuses: 'All statuses',
      use_case: 'Use Case',
      date: 'Date',
      table_name: 'Table name'
    },
    actions: {
      view_detail: 'View detail',
      view_activity: 'View activity',
      load_months: 'Load months',
      edit_script: 'Edit script',
      deactivate: 'Deactivate',
      update_metadata: 'Update metadata',
      change_status: 'Change status',
      hard_delete: 'Delete permanently',
      row_menu: 'Actions for {name}'
    },
    change_status: {
      warning: 'This only fixes the recorded status. It does not re-run the pipeline or the post-pipeline: if steps are still missing, use the per-step retry in "View activity".',
      target_label: 'Table',
      current_label: 'Current status',
      new_label: 'New status',
      reason_label: 'Reason for the change',
      reason_hint: 'State why you are changing the status manually (between 10 and 500 characters).',
      reason_required: 'The reason is required.',
      reason_min: 'The reason must be at least 10 characters long.',
      reason_max: 'The reason cannot exceed 500 characters.',
      confirm_btn: 'Change status',
      success: 'Status changed successfully.',
      rejected: 'The backend rejected the status change.',
      not_allowed: 'The current status does not allow a manual change.'
    },
    hard_delete: {
      // Permanent delete v2 (2026-10-01): one column, friction based on what is lost.
      dialog_heading: 'Permanently delete the attribute',
      close_label: 'Close without deleting',
      meta: 'Use case: {use_case} · Status: {status} · ID {id}',
      cannot_undo: 'This cannot be undone.',
      desc_nothing: 'It never loaded data: the record and its script are deleted, and the table name becomes free.',
      desc_data: 'The table and its data in BigQuery, AWS and Cloud Storage will be deleted, and the attribute will no longer appear in Attribute search.',
      desc_consumers: 'The table and its data in BigQuery, AWS and Cloud Storage will be deleted, and the attribute will no longer appear in Attribute search. Use cases that use it will lose access.',
      impact_title: 'What is lost',
      preview_loading: 'Checking what will be deleted…',
      preview_error_title: 'We could not check what will be deleted.',
      preview_error_text: 'Without this detail you cannot see whether someone uses the attribute.',
      preview_retry: 'Check again',
      preview_ack: 'Delete without seeing the detail',
      preview_ack_hint: 'The check failed again. If you continue, the deletion works the same, but you will not know who it affects.',
      tag_breaks: 'BREAKS',
      tag_unconfirmed: 'NOT CONFIRMED',
      tag_lost: 'CANNOT BE RECOVERED',
      tag_stops: 'STOPS',
      tag_hidden_too: 'ALSO HIDDEN',
      tag_platform: 'LEAVES INCA',
      tag_config: 'CONFIGURATION',
      tag_none: 'NO DATA',
      tag_kept: 'KEPT',
      tag_untouched: 'NOTHING TO DELETE',
      consumers_title: '{n} use case uses these attributes | {n} use cases use these attributes',
      consumers_text: 'Their sandboxes stop seeing these attributes as soon as the table is deleted.',
      consumers_toggle: 'See which',
      consumers_more: 'and {n} more',
      consumers_unknown_title: 'We could not check who uses these attributes',
      consumers_unknown_text: 'If you continue, the deletion works the same, but it may break use cases you cannot see here.',
      consumer_ref: 'Use case {id} · company {company}',
      consumer_active: 'Active until {date}',
      consumer_expired: 'Expired on {date}',
      consumer_other: 'Until {date}',
      runs_title: 'A load is running',
      runs_text: 'The running Step Functions and Glue execution is cancelled.',
      data_title: 'Data and catalog · {n} resource | Data and catalog · {n} resources',
      data_toggle: 'See technical detail',
      siblings_title: '{n} more table stops showing in Attribute search | {n} more tables stop showing in Attribute search',
      siblings_text: 'They share the “{alias}” category with this table. They are not deleted, but search hides them together.',
      siblings_toggle: 'See which',
      platform_title: 'Leaves Attribute search and Data Management',
      platform_text: 'It is hidden from search, its approval flow is cancelled and its metadata entry is deleted.',
      config_title: 'This environment has a configuration problem',
      config_text: 'Some steps cannot be completed. Let the platform team know.',
      config_toggle: 'See the detail',
      none_title: 'There are no tables or data to delete',
      none_text: 'The saved script is deleted and the record is marked as deleted.',
      kept_title: 'Audit trail',
      kept_text: 'Your reason, who deleted it and the load history.',
      untouched_title: '{n} step with nothing to delete | {n} steps with nothing to delete',
      untouched_toggle: 'See why',
      retention_note: 'Retained {days} day(s) · estimated purge {date}',
      alternative_title: 'Do you only want it to stop loading?',
      alternative_text: 'Deactivate it: it stops loading every month and leaves search, but the table and its data are kept and it does not break those who already use it.',
      alternative_btn: 'Deactivate instead',
      confirm_title: 'Confirm the deletion',
      reason_label: 'Reason for deletion',
      reason_hint: 'Between 10 and 500 characters. It is kept in the audit log.',
      reason_min: 'Write at least 10 characters.',
      name_instruction: 'To confirm, type {name}',
      name_label: 'Table name',
      name_mismatch: 'It does not match the table name.',
      force_label: 'Stop the running load',
      force_hint: 'The running Step Functions and Glue execution is cancelled.',
      ack_consumers: 'I understand that {n} use case will lose access to these attributes | I understand that {n} use cases will lose access to these attributes',
      ack_consumers_unknown: 'I understand that it was not possible to check who uses these attributes',
      confirm_btn: 'Permanently delete attribute',
      retry_btn: 'Retry deletion',
      sending_btn: 'Deleting…',
      sending_hint: 'Deleting… do not close this window.',
      sending_escape: 'The deletion is running. Wait for it to finish.',
      missing_prefix: 'To continue:',
      missing_and: 'and',
      missing_preview_loading: 'wait for the check to finish',
      missing_preview_retry: 'check again what will be deleted',
      missing_preview_ack: 'confirm that you delete without seeing the detail',
      missing_reason: 'write the reason (at least 10 characters)',
      missing_name: 'type the exact table name',
      missing_force: 'check “Stop the running load”',
      missing_ack: 'confirm that you understand who it affects',
      missing_in_progress: 'wait for the other deletion to finish',
      progress_title: 'Progress',
      progress_step: 'Step {current} of {total}: {label}',
      checklist_title: 'Attempt steps',
      checklist_hint: 'Retrying resumes from the first step that failed; what was already deleted is not repeated.',
      hidden_steps: 'and {n} step with nothing to delete | and {n} steps with nothing to delete',
      state_done: 'Done',
      state_run: 'Running',
      state_wait: 'Pending',
      state_fail: 'Failed',
      state_skip: 'Will be skipped',
      state_skipped: 'Skipped',
      state_none: 'Nothing to delete',
      skip_label: 'Skip this step (left for manual cleanup)',
      skip_blocked: 'It cannot be skipped: the attribute would be marked as deleted with its data still in AWS or in the database.',
      skip_warning: 'Skipped steps are not executed: what they clean up has to be done manually, but the attribute is still marked as deleted and releases the table name.',
      outcome_success: '{name} was deleted. The table name can be reused.',
      outcome_already: '{name} was already deleted.',
      outcome_partial_title: 'The deletion was left half done.',
      outcome_partial_text: '{done} of {total} steps finished. “{step}” failed: {detail}',
      outcome_partial_action: 'Retry: it resumes from that step. If it fails again on the same step, share the detail with the platform team. The table name stays reserved until it finishes.',
      outcome_partial_glue_action: 'Retry. If it fails again, the delete (DROP) permission is missing in the account that owns the Glue catalog: the data lake team grants it.',
      outcome_partial_dataplex_action: 'Retry. If it fails again, the operator user has no steward role in Data Management. If it is urgent, you can skip this step: the metadata entry will be left to delete manually.',
      outcome_in_progress_title: 'Someone else is already deleting this attribute.',
      outcome_in_progress_text: '{who} started the deletion at {time}. Wait for it to finish; if it does not move, you can resume it from {retry_time}.',
      outcome_in_progress_btn: 'See the status of that deletion',
      outcome_force_title: 'The automation started loading while you were confirming.',
      outcome_force_text: 'Check “Stop the running load” and try again.',
      outcome_forbidden_title: 'Your user cannot delete attributes.',
      outcome_forbidden_text: 'The attribute administrator role is required. Ask a platform administrator for it.',
      outcome_not_found_title: 'This automation no longer exists.',
      outcome_not_found_text: 'Close this dialog and refresh the list.',
      outcome_not_v2_title: 'This attribute cannot be deleted from here.',
      outcome_not_v2_text: 'Only attributes created with Create Attribute can be permanently deleted.',
      outcome_transition_title: 'The automation status changed while you were confirming.',
      outcome_transition_text: 'Close this dialog, refresh the list and try again.',
      outcome_error_title: 'The deletion could not finish.',
      outcome_error_text: 'The server responded with an error. Part of it may already be deleted.',
      outcome_error_action: 'Retry: the deletion resumes from where it stopped. If the error repeats, let the platform team know.',
      what_to_do: 'What to do:',
      groups: {
        data: 'Data and catalog',
        runs: 'Running executions',
        platform: 'INCA platform'
      },
      steps: {
        stepfunctions_stop: 'Cancel the Step Functions execution',
        glue_runs_stop: 'Stop the Glue runs',
        dynamodb_dedupe_delete: 'Delete the duplicate control (DynamoDB)',
        s3_lambda_cache_delete: 'Delete the SQL script in S3',
        s3_pending_script_delete: 'Delete the request script in S3',
        glue_get_table_location: 'Locate the table in the Glue catalog',
        s3_parquet_delete: 'Delete the Parquet data in S3',
        glue_delete_table: 'Delete the table from the Glue catalog',
        athena_staging_drop: 'Delete the Athena staging tables',
        athena_staging_preserved: 'Tables with a similar prefix that will NOT be touched',
        dataplex_metadata_delete: 'Delete the metadata entry in Data Management',
        bq_drop_final: 'Delete the final table in BigQuery',
        bq_drop_temps: 'Delete the temporary tables in BigQuery',
        gcs_scripts_delete: 'Delete the scripts in Cloud Storage',
        gcs_parquet_delete_v2: 'Delete the Parquet data in Cloud Storage',
        approval_flow_cancel: 'Cancel the approval flow',
        typesense_disable_category: 'Hide the attribute from Attribute search',
        pg_purge_children: 'Delete the loads recorded in INCA',
        attribute_group_delete: 'Delete the catalog category'
      },
      preview_objects: '{n} object(s)',
      runs_count: '{n} run(s)',
      tables_count: '{n} table(s)',
      versions_count: '{n} version(s)',
      rows_period_hist: '{period} periods · {hist} history rows'
    },
    load_months: {
      subtitle: 'Select the month and year you want to load for this existing automation.',
      background_hint: 'The process will continue in the background. You can close this dialog and check it again from "View activity".',
      periods_label: 'Added periods',
      max_periods_hint: 'Up to {max} periods per request.',
      too_many: 'Maximum 12 periods allowed.',
      summary_prefix: 'You will load',
      success_started: 'Load started for {count} period(s). We will notify you when it finishes.',
      badge_progress: 'Loading {done}/{total}'
    },
    edit_script: {
      current_info: 'Current automation',
      use_case: 'Use case',
      table_name: 'Table name',
      current_version: 'Current script version',
      current_filename: 'Current filename',
      new_script: 'New SQL script',
      parse_errors_title: 'Errors in SQL file — fix before continuing:',
      retrigger_info: 'On save, a new version is uploaded and the pipeline re-runs for all stored periods (Lambda → Glue → callback → S3/GCS/BigQuery → Typesense).',
      warn_in_progress: 'The automation is currently running. Editing now supersedes the in-flight run and triggers a new one.',
      success: 'Script updated to v{version}; pipeline re-triggered.'
    },
    sections: {
      basic_info: 'Basic information',
      sql_script: 'SQL Script'
    },
    form: {
      script_file: 'Script file (SQL)',
      month: 'Month',
      year: 'Year',
      periods: 'Periods',
      add_period: 'Add',
      use_case: 'Use Case',
      drag_file: 'Drag your file here',
      or: 'or',
      attach_file: 'Attach file',
      async_info: 'The creation process may take up to 5 minutes. You will be notified when complete.',
      table_description: 'Table description',
      table_description_placeholder: 'Briefly describe the content and purpose of the table',
      nombre_tabla: 'Table name',
      nombre_tabla_hint: 'Lowercase letters, numbers and underscores only (3-63 chars). E.g.: premium_segmentation'
    },
    rules: {
      file_required: 'File is required',
      file_size: 'File must not exceed 5MB',
      month_required: 'Month is required',
      year_required: 'Year is required',
      use_case_required: 'Use case is required',
      period_required: 'You must add at least one period',
      period_duplicate: 'This period has already been added',
      max_periods: 'Maximum {max} periods allowed',
      description_required: 'Description is required',
      description_max_length: 'Description must not exceed 500 characters',
      nombre_tabla_required: 'Table name is required',
      nombre_tabla_format: 'Only lowercase letters, numbers and underscores. Must start with a letter (3-63 characters)',
      load_months_pending_review: 'This automation is pending approval. It must be approved in "Manage requests" before loading months.'
    },
    errors: {
      select_period: 'Select between 1 and 12 periods',
      invalid_file_type: 'Only .sql files are allowed',
      table_not_ready: 'The table is not available yet'
    },
    partition_validation: {
      outside_db: 'Table "{table}" does not belong to the expected database ("{expected}").',
      missing_filter: 'Table "{table}" is partitioned. Add a WHERE filter for at least one of these columns: {cols}.',
      blocked: 'The SQL did not pass partition validation. Fix the indicated issues.',
      panel_title: 'The SQL did not pass partition validation',
      panel_subtitle: 'Fix the following issues in the script and validate again.',
      partition_column: 'Partition column',
      line: 'Line {n}',
      detected_code: 'Detected code',
      why_fails: 'Why it fails',
      how_to_fix: 'How to fix it',
      copy: 'Copy',
      copied: 'Copied to clipboard',
      no_suggestion: 'No suggestion available'
    },
    success: {
      created: 'Automation created successfully. The process will run in the background.',
      months_loaded: 'Months loaded successfully',
      deactivated: 'Automation deactivated successfully'
    },
    dialogs: {
      new_automation: 'New Automation',
      created_title: 'Success',
      created_activity_text: 'Automation created successfully. Do you want to view the process activity?',
      created_activity_yes: 'View activity',
      created_activity_no: 'Close',
      load_months_started_title: 'Load started',
      load_months_activity_text: 'Month load started successfully. Do you want to view the process activity?',
      detail: 'Attribute Detail',
      history: 'Load History',
      load_months: 'Load Months',
      edit_script: 'Edit Script',
      deactivate_title: 'Deactivate automation',
      deactivate_text: '{name} stops loading every month and leaves Attribute search. The table and its data are kept, so the sandboxes that already use it keep working. It cannot be reactivated from the platform today.',
      deactivate_yes: 'Deactivate',
      deactivate_this: 'This automation',
      deactivate_no: 'Cancel',
      change_status_title: 'Change status',
      hard_delete_title: 'Delete permanently'
    },
    detail: {
      tables_section: 'Generated tables',
      gcp_table: 'Data Management Table',
      model_table: 'BigQuery model table (S3 → GCS)',
      aws_table: 'BigQuery model table (S3 → GCS)',
      aws_output_table: 'Output table (AWS)',
      operator: 'Operator',
      executions_tab: 'Executions',
      periods_tab: 'Periods',
      download_script: 'Download original script',
      download_script_error: 'Could not download the original script'
    },
    history: {
      no_records: 'No history records',
      period: 'Period',
      start_date: 'Start Date',
      end_date: 'End Date',
      status: 'Status'
    },
    activity_timeline: {
      title: 'Automation Activity',
      empty: 'No executions registered yet.',
      load_more: 'Load more',
      periods: 'periods',
      retry: 'Retry',
      retry_all: 'Retry step ({count})',
      retry_from_step: 'Retry from step {step}',
      retry_success: 'Step retried successfully',
      retry_error: 'Error retrying step',
      incremental_note: 'Incremental load: only the selected periods are copied from S3 to GCS, the BigQuery model table is reloaded, and those periods are replaced in the final table. Catalog, AI and Typesense are already in sync from the initial creation.',
      aws_timeline_title: 'Detailed AWS flow',
      types: {
        creation: 'Initial creation',
        edit_script: 'Script edition',
        load_months: 'Incremental load'
      },
      overall: {
        success: 'Completed',
        partial_failure: 'With errors',
        in_progress: 'Running'
      },
      status: {
        pending: 'Pending',
        in_progress: 'In Progress',
        success: 'Completed',
        failed: 'Error',
        skipped: 'Skipped',
        unknown: 'Unknown'
      },
      steps: {
        aws_pipeline: 'AWS Execution (Athena/Glue)',
        duplicate_attribute_validation: 'Duplicate Attribute Validation',
        bq_dts_table: 'Load model S3 → GCS → BigQuery',
        bq_omni_table: 'BigQuery OMNI Table (legacy)',
        create_attribute_table: 'Materialize final table',
        metadata: 'Metadata Assignment',
        ai_column_metadata: 'Column Metadata (AI)',
        data_catalog_sync: 'Data Catalog Sync',
        create_category: 'Create Category',
        typesense_sync: 'Typesense Sync'
      }
    }
  }
};
import utils from '../js/utils.js';
import roles from './configuration/roles';
/* import help_center from './configuration/help_center' */
import my_objects from './data_platform/my_objects';
import my_pendings from './data_platform/my_pendings';
import monitoring from './data_platform/monitoring';
import my_tasks from './data_platform/my_tasks';
import requests from './data_platform/requests';
import data_quality from './data_platform/data_quality';
import chatbots from './chatbots/chatbots';
import btns from './data_platform/btns';
import config_aud from './audience/config';
import use_metrics from './data_platform/metrics';
import campaign from './campaign/campaign';
import report_management from './data_platform/report_management.js';
import migrations from './data_platform/migrations.js';
words.roles = {};
utils.loadLanguage(words.roles, roles, 'en');
// words.help_center = {}
// utils.loadLanguage(words.help_center2, help_center, 'en')
words.my_objects = {};
utils.loadLanguage(words.my_objects, my_objects, 'en');
words.my_pendings = {};
utils.loadLanguage(words.my_pendings, my_pendings, 'en');
words.monitoring = {};
utils.loadLanguage(words.monitoring, monitoring, 'en');
words.my_tasks = {};
utils.loadLanguage(words.my_tasks, my_tasks, 'en');
words.requests = {};
utils.loadLanguage(words.requests, requests, 'en');
words.data_quality = {};
utils.loadLanguage(words.data_quality, data_quality, 'en');
words.chatbots = {};
utils.loadLanguage(words.chatbots, chatbots, 'en');
words.btns = {};
utils.loadLanguage(words.btns, btns, 'en');
words.aud = {
  config: {}
};
utils.loadLanguage(words.aud.config, config_aud, 'en');
words.use_metrics = {};
utils.loadLanguage(words.use_metrics, use_metrics, 'en');
words.performance_evaluation = {
  evaluation: 'Evaluation',
  des_evaluation: 'Complete your performance evaluation. Your identification data is sent masked to the evaluation system.',
  reload: 'Refresh',
  not_configured: 'Evaluation not available',
  not_configured_detail: 'The performance evaluation site has not been configured yet. Contact the platform administrator.',
  token_error: 'Could not start the evaluation',
  token_error_detail: 'We could not validate your session with the evaluation system. Please try again in a few minutes.',
  debug_title: 'Data sent to the iframe (local only)'
};
words.campaign = {};
utils.loadLanguageRecursive(words.campaign, campaign, 'en');
words.report_management = {};
utils.loadLanguageRecursive(words.report_management, report_management, 'en');
words.migrations = {};
utils.loadLanguage(words.migrations, migrations, 'en');
export default words;